import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom"
import { useEffect, lazy, Suspense } from "react"
import { HelmetProvider } from "react-helmet-async"
import Seo from './components/Seo'
import Nav from './components/layout/Nav'
import Footer from './components/layout/Footer'
const Home = lazy(() => import('./pages/Home'))
const About = lazy(() => import('./pages/About'))
const CaseStudies = lazy(() => import('./pages/CaseStudies'))
const Platform = lazy(() => import('./pages/Platform'))
const Solutions = lazy(() => import('./pages/Solutions'))
const EsgRoiForCeos = lazy(() => import('./pages/EsgRoiForCeos'))
const EsgOperatingModel = lazy(() => import('./pages/EsgOperatingModel'))
const EsgAuditAssurance = lazy(() => import('./pages/EsgAuditAssurance'))
const SupplierEsgQualification = lazy(() => import('./pages/SupplierEsgQualification'))
const SustainableCapitalReadiness = lazy(() => import('./pages/SustainableCapitalReadiness'))
const PeFundraisingReadiness = lazy(() => import('./pages/PeFundraisingReadiness'))
const EsgForBanks = lazy(() => import('./pages/EsgForBanks'))
const EuAiActReadiness = lazy(() => import('./pages/EuAiActReadiness'))
const AiGovernanceOperatingModel = lazy(() => import('./pages/AiGovernanceOperatingModel'))
const AiRiskControlFramework = lazy(() => import('./pages/AiRiskControlFramework'))
const AiAssuranceReadiness = lazy(() => import('./pages/AiAssuranceReadiness'))
const Academy = lazy(() => import('./pages/Academy'))
const Certifications = lazy(() => import('./pages/academy/Certifications'))
const SeatManagement = lazy(() => import('./pages/academy/SeatManagement'))
const RequestQuote = lazy(() => import('./pages/academy/RequestQuote'))
const Masterclasses = lazy(() => import('./pages/academy/Masterclasses'))
const CertProgramme = lazy(() => import('./pages/academy/CertProgramme'))
const Insights = lazy(() => import('./pages/Insights'))
const BlogPost = lazy(() => import('./pages/BlogPost'))
const Contact = lazy(() => import('./pages/Contact'))
const IRIS = lazy(() => import('./pages/IRIS'))
const Press = lazy(() => import('./pages/Press'))
const EsgMaturityAssessment = lazy(() => import('./pages/EsgMaturityAssessment'))
const EsgOperatingModelDiagnostic = lazy(() => import('./pages/EsgOperatingModelDiagnostic'))
const ClimateWeekNyc = lazy(() => import('./pages/odcf/ClimateWeekNyc'))
const GoverningAiSwitzerland = lazy(() => import('./pages/masterclasses/GoverningAiSwitzerland'))
const AiGovernanceInActionSg = lazy(() => import('./pages/masterclasses/AiGovernanceInActionSg'))
const AiSustainabilityOfficer = lazy(() => import('./pages/masterclasses/AiSustainabilityOfficer'))
const NotFound = lazy(() => import('./pages/NotFound'))
const PortalLogin = lazy(() => import('./pages/portal/PortalLogin'))
const PortalDashboard = lazy(() => import('./pages/portal/PortalDashboard'))
const PortalAcademy = lazy(() => import('./pages/portal/PortalAcademy'))
const PortalProjects = lazy(() => import('./pages/portal/PortalProjects'))
const PortalAdminCourses = lazy(() => import('./pages/portal/PortalAdminCourses'))
const PortalAdminMasterclasses = lazy(() => import('./pages/portal/PortalAdminMasterclasses'))
const PortalAdminLeads = lazy(() => import('./pages/portal/PortalAdminLeads'))
const MagicLogin = lazy(() => import('./pages/portal/MagicLogin'))
const PortalProfile = lazy(() => import('./pages/portal/PortalProfile'))
const CourseContent = lazy(() => import('./pages/portal/CourseContent'))
const CecReadiness = lazy(() => import('./pages/portal/cec/CecReadiness'))
const CecT6Form = lazy(() => import('./pages/portal/cec/CecT6Form'))
const CecT3Form = lazy(() => import('./pages/portal/cec/CecT3Form'))
const CecT4Form = lazy(() => import('./pages/portal/cec/CecT4Form'))
const CecT2Form = lazy(() => import('./pages/portal/cec/CecT2Form'))
const CecT7Form = lazy(() => import('./pages/portal/cec/CecT7Form'))
const CecExam = lazy(() => import('./pages/portal/cec/CecExam'))
const CcsaSimulation = lazy(() => import('./pages/portal/lms/sims/ccsaSims/summative/CcsaSimulation'))
const QuestionBankIndex = lazy(() => import('./pages/portal/cec/QuestionBankIndex'))
const QuestionBank = lazy(() => import('./pages/portal/cec/QuestionBank'))
const ModuleAssessment = lazy(() => import('./pages/portal/ModuleAssessment'))
const MyCertificates = lazy(() => import('./pages/portal/MyCertificates'))
const MyGrades = lazy(() => import('./pages/portal/MyGrades'))
const MyCalendar = lazy(() => import('./pages/portal/MyCalendar'))
const PublicVerify = lazy(() => import('./pages/PublicVerify'))
const ResetPassword = lazy(() => import('./pages/portal/ResetPassword'))
const AdminCourseList = lazy(() => import('./pages/portal/lms/AdminCourseList'))
const AdminCourseEditor = lazy(() => import('./pages/portal/lms/AdminCourseEditor'))
const CourseDiagnosticAdmin = lazy(() => import('./pages/portal/lms/diagnostic/CourseDiagnosticAdmin'))
const AdminGradingQueue = lazy(() => import('./pages/portal/lms/AdminGradingQueue'))
const AdminGradingDetail = lazy(() => import('./pages/portal/lms/AdminGradingDetail'))
const DiagnosticQuiz = lazy(() => import('./pages/portal/lms/DiagnosticQuiz'))
const AdminEnrolmentDashboard = lazy(() => import('./pages/portal/lms/AdminEnrolmentDashboard'))
const AdminDirectEnrolment = lazy(() => import('./pages/portal/lms/AdminDirectEnrolment'))
const AdminEmailLog = lazy(() => import('./pages/portal/lms/AdminEmailLog'))
const AdminUsers = lazy(() => import('./pages/portal/lms/AdminUsers'))
const AdminUserDetail = lazy(() => import('./pages/portal/lms/AdminUserDetail'))
const MicroLesson = lazy(() => import('./pages/portal/lms/MicroLesson'))
const RequestTriagePage = lazy(() => import('./pages/portal/lms/sims/requestTriage/RequestTriagePage'))
const CriteriaBenchPage = lazy(() => import('./pages/portal/lms/sims/criteriaBench/CriteriaBenchPage'))
const InteractiveVideo = lazy(() => import('./pages/portal/lms/interactive/InteractiveVideo'))
const InteractiveLessonEditor = lazy(() => import('./pages/portal/lms/interactive/InteractiveLessonEditor'))
const CourseAssignments = lazy(() => import('./pages/portal/lms/CourseAssignments'))
const CourseFeedback = lazy(() => import('./pages/portal/lms/CourseFeedback'))
const AdminCourseFeedback = lazy(() => import('./pages/portal/lms/AdminCourseFeedback'))
const DefenceCapture = lazy(() => import('./pages/portal/lms/DefenceCapture'))
const AdminAssignmentGrading = lazy(() => import('./pages/portal/lms/AdminAssignmentGrading'))
const ClientProjectList = lazy(() => import('./pages/portal/consulting/ClientProjectList'))
const ClientProjectView = lazy(() => import('./pages/portal/consulting/ClientProjectView'))
const AdminProjectList = lazy(() => import('./pages/portal/consulting/AdminProjectList'))
const AdminProjectEditor = lazy(() => import('./pages/portal/consulting/AdminProjectEditor'))
const AcceptInvite = lazy(() => import('./pages/portal/consulting/AcceptInvite'))
const StaffManagement = lazy(() => import('./pages/portal/lms/StaffManagement'))
const StaffAcceptInvite = lazy(() => import('./pages/portal/lms/StaffAcceptInvite'))
// Instructor console (Sprint A2) — ONE code-split chunk; internal section routing lives inside it,
// so a learner's bundle never loads instructor code.
// Instructor pages — the console design rendered as regular /portal pages (no separate console shell).
const Gradebook = lazy(() => import('./pages/portal/console/sections/Gradebook'))
const Marking = lazy(() => import('./pages/portal/console/sections/Marking'))
const MarkingWorkspace = lazy(() => import('./pages/portal/console/sections/MarkingWorkspace'))
const Cohorts = lazy(() => import('./pages/portal/console/sections/Cohorts'))
const CohortDetail = lazy(() => import('./pages/portal/console/sections/CohortDetail'))
const Announcements = lazy(() => import('./pages/portal/console/sections/Announcements'))
const AssessmentConfig = lazy(() => import('./pages/portal/console/sections/AssessmentConfig'))
const Privacy = lazy(() => import('./pages/Privacy'))
import GATracker from './components/GATracker'
import CorpStageCookieConsent from './components/CookieConsent'
import './styles/globals.css'

// Suspense fallback while a lazy route chunk loads — a reserved-height spacer
// (not a spinner) so chunk loads never cause layout shift (CLS). The Nav/Footer
// shell stays visible above it.
const RouteFallback = () => <div style={{ minHeight: '70vh' }} aria-busy="true" />

// Scroll to top on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) {
      // Scroll to the anchored section (retry once for late-rendering content).
      const id = hash.slice(1)
      const go = () => { const el = document.getElementById(id); if (el) { el.scrollIntoView({ behavior: 'smooth' }); return true } return false }
      if (!go()) setTimeout(go, 250)
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname, hash])
  return null
}

// On the portal.corpstage.com custom domain, keep only the portal app + auth routes here and
// send the bare root to the portal dashboard. Everything else on that host is a marketing page
// that must live on www.corpstage.com, so redirect it there. This is an interim client-side
// stopgap for the duplicate-content leak (portal.corpstage.com serving /insights, /about, etc.):
// a true server-side 301 belongs in Azure Front Door. Canonical tags already point to www, so
// this mainly stops users and crawlers landing on the portal copy. www is a different host, so
// the guard below means this never runs there (no redirect loop).
const PORTAL_ONLY_PREFIXES = ['/portal', '/login', '/magic-login', '/reset-password', '/verify']

function PortalHostRedirect() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  useEffect(() => {
    if (window.location.hostname !== 'portal.corpstage.com') return
    if (pathname === '/') {
      navigate('/portal/dashboard', { replace: true })
      return
    }
    const isPortalRoute = PORTAL_ONLY_PREFIXES.some(
      (p) => pathname === p || pathname.startsWith(p + '/')
    )
    if (!isPortalRoute) {
      const { search, hash } = window.location
      window.location.replace('https://www.corpstage.com' + pathname + search + hash)
    }
  }, [pathname, navigate])
  return null
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <PortalHostRedirect />
        <GATracker />
        <Seo />
        <Suspense fallback={<RouteFallback />}>
          <AppShell />
        </Suspense>
        <CorpStageCookieConsent />
      </BrowserRouter>
    </HelmetProvider>
  )
}

// Portal routes render standalone (own PortalLayout). Everything else keeps the
// marketing Nav + Footer chrome.
function AppShell() {
  const { pathname } = useLocation()

  // Public certificate verification — standalone, no portal chrome, no nav/footer.
  if (pathname.startsWith('/verify/')) {
    return (
      <Routes>
        <Route path="/verify/:credentialId" element={<PublicVerify />} />
      </Routes>
    )
  }

  // Public consulting invite acceptance — standalone, no portal chrome (like /verify).
  if (pathname.startsWith('/consulting/accept-invite')) {
    return (
      <Routes>
        <Route path="/consulting/accept-invite" element={<AcceptInvite />} />
      </Routes>
    )
  }

  // Public staff invite acceptance — standalone, no portal chrome.
  if (pathname.startsWith('/staff/accept-invite')) {
    return (
      <Routes>
        <Route path="/staff/accept-invite" element={<StaffAcceptInvite />} />
      </Routes>
    )
  }

  // Public password reset (from the emailed link) — standalone, no portal chrome.
  if (pathname.startsWith('/reset-password')) {
    return (
      <Routes>
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    )
  }

  if (pathname.startsWith('/portal') || pathname.startsWith('/magic-login') || pathname.startsWith('/consulting')) {
    return (
      <Routes>
        <Route path="/magic-login"      element={<MagicLogin />} />
        <Route path="/portal/login"     element={<PortalLogin />} />
        <Route path="/portal/admin/gradebook" element={<Gradebook />} />
        <Route path="/portal/admin/marking" element={<Marking />} />
        <Route path="/portal/admin/marking/:submissionId" element={<MarkingWorkspace />} />
        <Route path="/portal/admin/cohorts" element={<Cohorts />} />
        <Route path="/portal/admin/announcements" element={<Announcements />} />
        <Route path="/portal/admin/assessment-config" element={<AssessmentConfig />} />
        <Route path="/portal/admin/cohorts/:cohortId" element={<CohortDetail />} />
        <Route path="/portal/dashboard" element={<PortalDashboard />} />
        <Route path="/portal/academy"   element={<PortalAcademy />} />
        <Route path="/portal/academy/courses/:courseId/content" element={<CourseContent />} />
        <Route path="/portal/academy/courses/:courseId/modules/:moduleId/assessment" element={<ModuleAssessment />} />
        <Route path="/portal/academy/certificates" element={<MyCertificates />} />
        <Route path="/portal/academy/grades" element={<MyGrades />} />
        <Route path="/portal/academy/calendar" element={<MyCalendar />} />
        <Route path="/portal/academy/cec/m1" element={<CecReadiness />} />
        <Route path="/portal/academy/cec/m1/t6" element={<CecT6Form />} />
        <Route path="/portal/academy/cec/m1/t3" element={<CecT3Form />} />
        <Route path="/portal/academy/cec/m1/t4" element={<CecT4Form />} />
        <Route path="/portal/academy/cec/m1/t2" element={<CecT2Form />} />
        <Route path="/portal/academy/cec/m1/t7" element={<CecT7Form />} />
        <Route path="/portal/academy/cec/m1/exam" element={<CecExam />} />
        <Route path="/portal/academy/cec/exam/:moduleCode" element={<CecExam />} />
        <Route path="/portal/academy/cec/exam/:credentialCode/:moduleCode" element={<CecExam />} />
        <Route path="/portal/academy/cec/simulation/:credentialCode/:moduleCode" element={<CcsaSimulation />} />
        <Route path="/portal/admin/question-bank" element={<QuestionBankIndex />} />
        <Route path="/portal/admin/question-bank/:credential" element={<QuestionBank />} />
        <Route path="/portal/academy/courses/:courseId/diagnostic" element={<DiagnosticQuiz />} />
        <Route path="/portal/academy/courses/:courseId/modules/:moduleId/micro/:microLessonId" element={<MicroLesson />} />
        <Route path="/portal/academy/interactive/:lessonId" element={<InteractiveVideo />} />
        <Route path="/portal/academy/sims/request-triage" element={<RequestTriagePage />} />
        <Route path="/portal/academy/sims/criteria-bench" element={<CriteriaBenchPage />} />
        <Route path="/portal/academy/courses/:courseId/assignments" element={<CourseAssignments />} />
        <Route path="/portal/academy/courses/:courseId/feedback" element={<CourseFeedback />} />
        <Route path="/portal/defence/:sessionId" element={<DefenceCapture />} />
        <Route path="/portal/projects"  element={<PortalProjects />} />
        <Route path="/portal/profile"   element={<PortalProfile />} />
        <Route path="/portal/admin/courses" element={<PortalAdminCourses />} />
        <Route path="/portal/admin/masterclasses" element={<PortalAdminMasterclasses />} />
        <Route path="/portal/admin/leads" element={<PortalAdminLeads />} />
        <Route path="/portal/admin/lms/courses" element={<AdminCourseList />} />
        <Route path="/portal/admin/lms/courses/:courseId" element={<AdminCourseEditor />} />
        <Route path="/portal/admin/lms/courses/:courseId/diagnostic" element={<CourseDiagnosticAdmin />} />
        <Route path="/portal/admin/lms/courses/:courseId/feedback" element={<AdminCourseFeedback />} />
        <Route path="/portal/admin/lms/interactive/:moduleId" element={<InteractiveLessonEditor />} />
        <Route path="/portal/admin/lms/grading" element={<AdminGradingQueue />} />
        <Route path="/portal/admin/lms/grading/assignment/:submissionId" element={<AdminAssignmentGrading />} />
        <Route path="/portal/admin/lms/grading/:attemptId" element={<AdminGradingDetail />} />
        <Route path="/portal/admin/lms/enrolments" element={<AdminEnrolmentDashboard />} />
        <Route path="/portal/admin/lms/enrolments/new" element={<AdminDirectEnrolment />} />
        <Route path="/portal/admin/staff" element={<StaffManagement />} />
        <Route path="/portal/admin/email-log" element={<AdminEmailLog />} />
        <Route path="/portal/admin/users" element={<AdminUsers />} />
        <Route path="/portal/admin/users/:userId" element={<AdminUserDetail />} />
        {/* Consulting — client (gated inside by nav/role; data gated server-side) */}
        <Route path="/consulting" element={<ClientProjectList />} />
        <Route path="/consulting/projects/:projectId" element={<ClientProjectView />} />
        {/* Consulting — admin / account manager */}
        <Route path="/consulting/admin" element={<AdminProjectList />} />
        <Route path="/consulting/admin/projects/:projectId" element={<AdminProjectEditor />} />
      </Routes>
    )
  }

  return (
    <>
      <Nav />
      <main>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/"                  element={<Home />} />
          <Route path="/about"             element={<About />} />
          <Route path="/case-studies"      element={<CaseStudies />} />
          <Route path="/platform"          element={<Platform />} />
          <Route path="/platform/esg-360"  element={<Navigate to="/platform" replace />} />
          <Route path="/platform/aivara"   element={<Navigate to="/platform" replace />} />
          <Route path="/solutions"                 element={<Solutions />} />
          <Route path="/solutions/esg-roi-for-ceos" element={<EsgRoiForCeos />} />
          <Route path="/solutions/esg-operating-model-design" element={<EsgOperatingModel />} />
          <Route path="/solutions/esg-audit-assurance-readiness" element={<EsgAuditAssurance />} />
          <Route path="/solutions/supplier-esg-buyer-qualification" element={<SupplierEsgQualification />} />
          <Route path="/solutions/sustainable-capital-readiness" element={<SustainableCapitalReadiness />} />
          <Route path="/solutions/pe-fundraising-readiness" element={<PeFundraisingReadiness />} />
          <Route path="/solutions/esg-for-banks-and-fi" element={<EsgForBanks />} />
          <Route path="/solutions/eu-ai-act-readiness" element={<EuAiActReadiness />} />
          <Route path="/solutions/ai-governance-operating-model" element={<AiGovernanceOperatingModel />} />
          <Route path="/solutions/ai-risk-control-framework" element={<AiRiskControlFramework />} />
          <Route path="/solutions/ai-assurance-readiness" element={<AiAssuranceReadiness />} />
          <Route path="/academy"                 element={<Academy />} />
          <Route path="/academy/certifications"  element={<Certifications />} />
          <Route path="/academy/seats"           element={<SeatManagement />} />
          <Route path="/academy/request-quote"   element={<RequestQuote />} />
          <Route path="/academy/masterclasses"   element={<Masterclasses />} />
          <Route path="/academy/masterclasses/governing-ai-switzerland" element={<GoverningAiSwitzerland />} />
          <Route path="/academy/masterclasses/ai-governance-in-action-singapore" element={<AiGovernanceInActionSg />} />
          <Route path="/academy/masterclasses/ai-sustainability-officer" element={<AiSustainabilityOfficer />} />
          <Route path="/academy/cea-001"         element={<Navigate to="/academy/ceda-001" replace />} />
          <Route path="/academy/ceda-001"        element={<CertProgramme slug="ceda-001" />} />
          <Route path="/academy/ccsa-001"        element={<CertProgramme slug="ccsa-001" />} />
          <Route path="/academy/cec-001"         element={<CertProgramme slug="cec-001" />} />
          <Route path="/academy/caigl-001"       element={<CertProgramme slug="caigl-001" />} />
          <Route path="/academy/caiap-001"       element={<CertProgramme slug="caiap-001" />} />
          <Route path="/academy/cairo-001"       element={<CertProgramme slug="cairo-001" />} />
          <Route path="/insights"          element={<Insights />} />
          <Route path="/insights/:slug"    element={<BlogPost />} />
          <Route path="/contact"           element={<Contact />} />
          <Route path="/privacy"           element={<Privacy />} />
          <Route path="/press"             element={<Press />} />
          <Route path="/esg-maturity-assessment" element={<EsgMaturityAssessment />} />
          <Route path="/esg-operating-model-diagnostic" element={<EsgOperatingModelDiagnostic />} />
          <Route path="/odcf/climate-week-nyc" element={<ClimateWeekNyc />} />
          <Route path="/ask-iris"          element={<IRIS />} />
          <Route path="/login"             element={<Navigate to="/portal/login" replace />} />
          <Route path="*"                  element={<NotFound />} />
        </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  )
}
